"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rogueAnim = exports.rogueCursor = void 0;
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueMonofont_1 = require("../monofont/rogueMonofont");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueRunner_sidecar_1 = require("../scene/rogueRunner-sidecar");
var rogueGlyphs_sidecar_1 = require("../targeting/rogueGlyphs-sidecar");
var rogueAanimManager_sidecar_1 = require("./rogueAanimManager-sidecar");
var key = 'detect-living';
// export const getSpellStats = () => {
//   return rogueSpellData.getSpellStats(key)
// }
// export function getSpellData(): IRogueSpellData {
//   return {}
// }
function rogueCursor(gridX, gridY, activate) {
    if (activate) {
        rogueAanimManager_sidecar_1.rogueAanimManager.addAnim(rogueAnim());
    }
}
exports.rogueCursor = rogueCursor;
function rogueAnim() {
    var delay, map, monsters, i, t;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                delay = 0.25;
                return [4 /*yield*/, { delay: delay }];
            case 1:
                _a.sent();
                map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
                monsters = [];
                rogueMonsters_sidecar_1.rogueMonsters.getAll().forEach(function (m) {
                    if (m.data.isFriendly) {
                        monsters.push(m);
                    }
                });
                monsters = monsters.sort(function (a, b) {
                    var d1 = a.x + a.y;
                    var d2 = b.x + b.y;
                    return d1 - d2;
                });
                i = 0;
                _a.label = 2;
            case 2:
                if (!(i < monsters.length)) return [3 /*break*/, 5];
                t = monsters[i];
                rogueGlyphs_sidecar_1.rogueGlyphs.write(t.x, t.y, 'target', rogueDef_sidecar_1.rogueDef.colors.light, 5);
                rogueGlyphs_sidecar_1.rogueGlyphs.write(t.x, t.y, 'X', rando_sidecar_1.rando.sample(rogueMonofont_1.waterScale), 5);
                return [4 /*yield*/, { delay: delay }];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                i++;
                return [3 /*break*/, 2];
            case 5:
                rogueRunner_sidecar_1.rogueRunner.setPlayerUsedTurn();
                return [2 /*return*/];
        }
    });
}
exports.rogueAnim = rogueAnim;
